import type { JSX } from 'react';

import Image from 'next/image';

import Body from 'DesignSystem3/Text/Body';
import Emphasis from 'DesignSystem3/Text/Emphasis';
import Headline from 'DesignSystem3/Text/Headline';

import FaceOffNumber from './AnimatedOdds';

interface HeroCardProps {
    isCVariant: boolean;
    isTrump: boolean;
    odds: number;
    change: number;
    left: boolean;
    darkMode: boolean;
}

const HeroCard = ({ isCVariant, isTrump, odds, change, left, darkMode }: HeroCardProps): JSX.Element => {
    const canidateText = isTrump ? 'Trump' : 'Harris';
    const cardTitle = isCVariant ? canidateText : `Will ${canidateText} win?`;
    return (
        <div
            className={
                'flex gap-1 ' +
                (!left ? 'flex-row-reverse ' : '') +
                (isCVariant ? '' : 'px-2  border border-1 border-fill-x50 border-solid rounded-x30 bg-surface-x10')
            }
        >
            <Image
                src={
                    isTrump
                        ? `/images/elections_dash/${darkMode ? 'dark' : 'light'}-Trump-neutral.webp`
                        : `/images/elections_dash/${darkMode ? 'dark' : 'light'}-Kamala-neutral.webp`
                }
                width={isCVariant ? 120 : 100}
                height={isCVariant ? 96 : 80}
                alt={canidateText}
                priority
                className="self-end"
            />
            <div
                className={
                    'flex flex-col py-2 text-text-x10 ' + (isCVariant ? 'gap-[2px] ' : '') + (!left ? 'items-end' : '')
                }
            >
                <Body.x20>{cardTitle}</Body.x20>
                <div
                    className={
                        'flex ' +
                        (isCVariant ? 'flex-col ' : 'flex-row gap-[4px] items-center ') +
                        (!left ? 'items-end' : '')
                    }
                >
                    <Headline.x20>
                        <FaceOffNumber odds={odds} change={change} />
                    </Headline.x20>
                    <div className="flex min-h-[18px]">
                        {change !== 0 && (
                            <div className={'flex ' + (change > 0 ? 'text-green-x10' : 'text-red-x10')}>
                                <Emphasis.x10>{change > 0 ? '▲' : '▼'}</Emphasis.x10>
                                <Emphasis.x10>{Math.abs(change)}</Emphasis.x10>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HeroCard;
